export const TARIFFS_LOADER_TYPE = 'tariffsAbie';